import { useCallback, useState } from 'react';
import { Airwave } from '@crabs-ai/web-icons';
import { Button, ToolButton, Tooltip } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { collapseTrackGaps } from '../../state/actions/collapse-track-gaps';
import {
  disableMagnetic,
  enableMagnetic,
  getLinkedTrackIdsForMagnetic,
} from '../../state/actions/magnetic-track';
import { TrackType } from '../../state/types';
import { useWriteContext } from '../../utils/use-context';
import { RippleEditGuideDialog } from './ripple-edit-guide-dialog';

export const TimelineMagneticTrack = ({ track }: { track: TrackType }) => {
  const { setState } = useWriteContext();
  const t = useTranslations();
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  const toggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      if (track.magnetic) {
        setState({
          update: (state) => {
            return disableMagnetic(state, track.id);
          },
          commitToUndoStack: true,
        });
      } else {
        setState({
          update: (state) => {
            const withMagnetic = enableMagnetic(state, track.id);

            const linkedTrackIds = getLinkedTrackIdsForMagnetic(
              state,
              track.id,
            );
            let result = withMagnetic;
            for (const trackId of linkedTrackIds) {
              result = collapseTrackGaps(result, trackId);
            }
            return result;
          },
          commitToUndoStack: true,
        });
      }
    },
    [track.magnetic, setState, track.id],
  );

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <>
      <Tooltip
        type="withButton"
        side="top"
        className="items-center"
        textNode={
          track.magnetic
            ? t('Editor.timeline.ripple-edit-off')
            : t('Editor.timeline.ripple-edit-on')
        }
        buttonNode={
          <Button
            size="xsmall"
            hierarchy="tertiary"
            onClick={() => setIsGuideOpen(true)}
          >
            {t('Editor.timeline.ripple-edit-what')}
          </Button>
        }
      >
        <ToolButton
          size="sm"
          state={track.magnetic ? 'selected' : 'default'}
          onClick={toggle}
          onPointerDown={onPointerDown}
        >
          <Airwave />
        </ToolButton>
      </Tooltip>

      <RippleEditGuideDialog
        open={isGuideOpen}
        onOpenChange={setIsGuideOpen}
      />
    </>
  );
};
